module.exports = __webpack_public_path__ + "static/media/plastico.eb06628b.png";